module.exports = __webpack_public_path__ + "media/images/pc/items/gift/kiribako_02-cab8fa5aa6777ac64a6247a21d74a86e.jpg";